
import { useState } from 'react';
import { Sidebar } from '../components/dashboard/Sidebar.jsx';
import { ActivityHeatmap } from '../components/dashboard/ActivityHeatmap.jsx';
import { ConnectionGroup } from '../components/dashboard/ConnectionGroup.jsx';
import {
    ChevronUp,
    ChevronDown,
    FileText
} from
    'lucide-react';
import './ProfilePage.css';
import { useSelector } from 'react-redux';

const tabs = [
    'Overview',
    'Joining',
    'Address & Contacts',
    'Attendance & Leaves',
    'Salary',
    'Personal',
    'Profile',
    'Exit',
    'Connections'];


const connectionData = {
    attendance: [
        { label: 'Attendance', count: 1 },
        { label: 'Attendance Request' },
        { label: 'Employee Checkin' }],

    leave: [
        { label: 'Leave Application' },
        { label: 'Leave Allocation' },
        { label: 'Leave Policy Assignment' }],

    lifecycle: [
        { label: 'Employee Transfer' },
        { label: 'Employee Promotion' },
        { label: 'Employee Grievance' }],

    exit: [
        { label: 'Full and Final Statement' }],

    shift: [
        { label: 'Shift Request' },
        { label: 'Shift Assignment' }],

    expense: [
        { label: 'Expense Claim' },
        { label: 'Employee Advance' }],

    benefit: [
        { label: 'Employee Benefit Application' }],

    payroll: [
        { label: 'Salary Structure Assignment' }],

    evaluation: [
        { label: 'Appraisal' }]

};

function SectionHeader({ title, isOpen, onToggle }) {
    return (
        <button onClick={onToggle} className="section-header">
            <h2>{title}</h2>
            {isOpen ? <ChevronUp /> : <ChevronDown />}
        </button>);

}

// Tab Content Components
function OverviewContent() {
    return (
        <div>
            <div className="content-card">
                <h3>Employee Summary</h3>
                <div className="info-grid">
                    <div className="info-item">
                        <span className="info-label">Employee ID</span>
                        <span className="info-value">EMP-2024-0089</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Department</span>
                        <span className="info-value">Engineering</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Designation</span>
                        <span className="info-value">Senior Software Engineer</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Reports To</span>
                        <span className="info-value">John Smith (Engineering Manager)</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Employment Type</span>
                        <span className="info-value">Full Time</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Date of Joining</span>
                        <span className="info-value">March 15, 2024</span>
                    </div>
                </div>
            </div>

            <div className="stats-grid">
                <div className="stat-card">
                    <div className="stat-value">22</div>
                    <div className="stat-label">Days Present</div>
                </div>
                <div className="stat-card">
                    <div className="stat-value">2</div>
                    <div className="stat-label">Days Absent</div>
                </div>
                <div className="stat-card">
                    <div className="stat-value">12</div>
                    <div className="stat-label">Leave Balance</div>
                </div>
                <div className="stat-card">
                    <div className="stat-value">4.5</div>
                    <div className="stat-label">Performance Rating</div>
                </div>
            </div>
        </div>);

}

function JoiningContent() {
    return (
        <div>
            <div className="content-card">
                <h3>Joining Details</h3>
                <div className="info-grid">
                    <div className="info-item">
                        <span className="info-label">Offer Date</span>
                        <span className="info-value">February 28, 2024</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Joining Date</span>
                        <span className="info-value">March 15, 2024</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Confirmation Date</span>
                        <span className="info-value">June 15, 2024</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Probation Period</span>
                        <span className="info-value">3 Months</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Notice Period</span>
                        <span className="info-value">30 Days</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Contract End Date</span>
                        <span className="info-value">-</span>
                    </div>
                </div>
            </div>

            <div className="content-card">
                <h3>Onboarding Checklist</h3>
                <div className="timeline-item">
                    <div className="timeline-dot" style={{ backgroundColor: '#16a34a' }}></div>
                    <div className="timeline-content">
                        <h4>Documents Submitted</h4>
                        <p>All required documents have been submitted and verified</p>
                    </div>
                </div>
                <div className="timeline-item">
                    <div className="timeline-dot" style={{ backgroundColor: '#16a34a' }}></div>
                    <div className="timeline-content">
                        <h4>IT Assets Assigned</h4>
                        <p>Laptop, access cards, and software licenses assigned</p>
                    </div>
                </div>
                <div className="timeline-item">
                    <div className="timeline-dot" style={{ backgroundColor: '#16a34a' }}></div>
                    <div className="timeline-content">
                        <h4>Training Completed</h4>
                        <p>Orientation and compliance training completed</p>
                    </div>
                </div>
            </div>
        </div>);

}

function AddressContactsContent() {
    return (
        <div>
            <div className="content-card">
                <h3>Current Address</h3>
                <div className="info-grid">
                    <div className="info-item">
                        <span className="info-label">Address Line 1</span>
                        <span className="info-value">123 Main Street, Apt 4B</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">City</span>
                        <span className="info-value">San Francisco</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">State</span>
                        <span className="info-value">California</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Postal Code</span>
                        <span className="info-value">94102</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Country</span>
                        <span className="info-value">United States</span>
                    </div>
                </div>
            </div>

            <div className="content-card">
                <h3>Contact Information</h3>
                <div className="info-grid">
                    <div className="info-item">
                        <span className="info-label">Personal Email</span>
                        <span className="info-value">lolo09@email.com</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Work Email</span>
                        <span className="info-value">lolo09@company.com</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Mobile Phone</span>
                        <span className="info-value">+1 (555) 123-4567</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Emergency Contact</span>
                        <span className="info-value">Jane Doe - +1 (555) 987-6543</span>
                    </div>
                </div>
            </div>
        </div>);

}

function AttendanceLeavesContent() {
    return (
        <div>
            <div className="stats-grid">
                <div className="stat-card">
                    <div className="stat-value">22</div>
                    <div className="stat-label">Present Days</div>
                </div>
                <div className="stat-card">
                    <div className="stat-value">2</div>
                    <div className="stat-label">Absent Days</div>
                </div>
                <div className="stat-card">
                    <div className="stat-value">1</div>
                    <div className="stat-label">Half Days</div>
                </div>
                <div className="stat-card">
                    <div className="stat-value">95%</div>
                    <div className="stat-label">Attendance Rate</div>
                </div>
            </div>

            <div className="content-card">
                <h3>Leave Balance</h3>
                <div className="info-grid">
                    <div className="info-item">
                        <span className="info-label">Annual Leave</span>
                        <span className="info-value">12 days remaining</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Sick Leave</span>
                        <span className="info-value">5 days remaining</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Personal Leave</span>
                        <span className="info-value">3 days remaining</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Comp Off</span>
                        <span className="info-value">2 days available</span>
                    </div>
                </div>
            </div>

            <div className="content-card">
                <h3>Recent Leave History</h3>
                <div className="timeline-item">
                    <div className="timeline-dot"></div>
                    <div className="timeline-content">
                        <h4>Annual Leave - Approved</h4>
                        <p>Dec 23 - Dec 27, 2024 (5 days)</p>
                    </div>
                </div>
                <div className="timeline-item">
                    <div className="timeline-dot"></div>
                    <div className="timeline-content">
                        <h4>Sick Leave - Approved</h4>
                        <p>Nov 15, 2024 (1 day)</p>
                    </div>
                </div>
            </div>
        </div>);

}

function SalaryContent() {
    return (
        <div>
            <div className="content-card">
                <h3>Salary Structure</h3>
                <div className="salary-row">
                    <span className="salary-label">Basic Salary</span>
                    <span className="salary-value">$6,000.00</span>
                </div>
                <div className="salary-row">
                    <span className="salary-label">Housing Allowance</span>
                    <span className="salary-value">$1,500.00</span>
                </div>
                <div className="salary-row">
                    <span className="salary-label">Transport Allowance</span>
                    <span className="salary-value">$500.00</span>
                </div>
                <div className="salary-row">
                    <span className="salary-label">Medical Allowance</span>
                    <span className="salary-value">$300.00</span>
                </div>
                <div className="salary-row">
                    <span className="salary-label">Tax Deduction</span>
                    <span className="salary-value negative">-$1,200.00</span>
                </div>
                <div className="salary-row">
                    <span className="salary-label">Insurance Deduction</span>
                    <span className="salary-value negative">-$200.00</span>
                </div>
                <div className="salary-row">
                    <span className="salary-label">Net Salary</span>
                    <span className="salary-value positive">$6,900.00</span>
                </div>
            </div>

            <div className="content-card">
                <h3>Bank Details</h3>
                <div className="info-grid">
                    <div className="info-item">
                        <span className="info-label">Bank Name</span>
                        <span className="info-value">Chase Bank</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Account Number</span>
                        <span className="info-value">****4567</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Routing Number</span>
                        <span className="info-value">****8901</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Payment Mode</span>
                        <span className="info-value">Direct Deposit</span>
                    </div>
                </div>
            </div>
        </div>);

}

function PersonalContent() {
    return (
        <div>
            <div className="content-card">
                <h3>Personal Information</h3>
                <div className="info-grid">
                    <div className="info-item">
                        <span className="info-label">Full Name</span>
                        <span className="info-value">Lolo09 Lala Lulu</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Date of Birth</span>
                        <span className="info-value">January 15, 1990</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Gender</span>
                        <span className="info-value">Male</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Marital Status</span>
                        <span className="info-value">Single</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Nationality</span>
                        <span className="info-value">American</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Blood Group</span>
                        <span className="info-value">O+</span>
                    </div>
                </div>
            </div>

            <div className="content-card">
                <h3>Education</h3>
                <div className="timeline-item">
                    <div className="timeline-dot"></div>
                    <div className="timeline-content">
                        <h4>Master of Computer Science</h4>
                        <p>Stanford University - 2014</p>
                    </div>
                </div>
                <div className="timeline-item">
                    <div className="timeline-dot"></div>
                    <div className="timeline-content">
                        <h4>Bachelor of Computer Science</h4>
                        <p>UC Berkeley - 2012</p>
                    </div>
                </div>
            </div>
        </div>);

}

function ProfileContent() {
    return (
        <div>
            <div className="content-card">
                <h3>Work Experience</h3>
                <div className="timeline-item">
                    <div className="timeline-dot"></div>
                    <div className="timeline-content">
                        <h4>Senior Software Engineer - Current Company</h4>
                        <p>March 2024 - Present</p>
                    </div>
                </div>
                <div className="timeline-item">
                    <div className="timeline-dot" style={{ backgroundColor: '#9ca3af' }}></div>
                    <div className="timeline-content">
                        <h4>Software Engineer - Tech Corp</h4>
                        <p>June 2018 - February 2024</p>
                    </div>
                </div>
                <div className="timeline-item">
                    <div className="timeline-dot" style={{ backgroundColor: '#9ca3af' }}></div>
                    <div className="timeline-content">
                        <h4>Junior Developer - StartupXYZ</h4>
                        <p>January 2015 - May 2018</p>
                    </div>
                </div>
            </div>

            <div className="content-card">
                <h3>Skills & Certifications</h3>
                <div className="info-grid">
                    <div className="info-item">
                        <span className="info-label">Primary Skills</span>
                        <span className="info-value">React, Node.js, Python, AWS</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Certifications</span>
                        <span className="info-value">AWS Solutions Architect, Scrum Master</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Languages</span>
                        <span className="info-value">English (Native), Spanish (Intermediate)</span>
                    </div>
                </div>
            </div>
        </div>);

}

function ExitContent() {
    return (
        <div>
            <div className="empty-state">
                <FileText />
                <p>No exit process initiated for this employee.</p>
                <p style={{ marginTop: '8px', fontSize: '12px' }}>Exit details will appear here when the separation process begins.</p>
            </div>
        </div>);

}

function ConnectionsContent({ sectionsOpen, toggleSection }) {
    return (
        <div>
            <div style={{ marginBottom: '32px' }}>
                <SectionHeader
                    title="Activity"
                    isOpen={sectionsOpen.activity}
                    onToggle={() => toggleSection('activity')} />

                {sectionsOpen.activity &&
                    <div style={{ marginTop: '8px' }}>
                        <ActivityHeatmap />
                    </div>
                }
            </div>

            <div>
                <SectionHeader
                    title="Connections"
                    isOpen={sectionsOpen.connections}
                    onToggle={() => toggleSection('connections')} />

                {sectionsOpen.connections &&
                    <div className="connections-grid">
                        <ConnectionGroup title="Attendance" items={connectionData.attendance} />
                        <ConnectionGroup title="Leave" items={connectionData.leave} />
                        <ConnectionGroup title="Lifecycle" items={connectionData.lifecycle} />
                        <ConnectionGroup title="Exit" items={connectionData.exit} />
                        <ConnectionGroup title="Shift" items={connectionData.shift} />
                        <ConnectionGroup title="Expense" items={connectionData.expense} />
                        <ConnectionGroup title="Benefit" items={connectionData.benefit} />
                        <ConnectionGroup title="Payroll" items={connectionData.payroll} />
                        <ConnectionGroup title="Evaluation" items={connectionData.evaluation} />
                    </div>
                }
            </div>
        </div>);

}

const ProfilePage = () => {
    const { user } = useSelector((state) => state.auth);
    //const { updateProfile } = useAuth();
    const [activeTab, setActiveTab] = useState('Connections');
    const [sectionsOpen, setSectionsOpen] = useState({
        activity: true,
        connections: true
    });

    const toggleSection = (section) => {
        setSectionsOpen((prev) => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 'Overview':
                return <OverviewContent />;
            case 'Joining':
                return <JoiningContent />;
            case 'Address & Contacts':
                return <AddressContactsContent />;
            case 'Attendance & Leaves':
                return <AttendanceLeavesContent />;
            case 'Salary':
                return <SalaryContent />;
            case 'Personal':
                return <PersonalContent />;
            case 'Profile':
                return <ProfileContent />;
            case 'Exit':
                return <ExitContent />;
            case 'Connections':
                return <ConnectionsContent sectionsOpen={sectionsOpen} toggleSection={toggleSection} />;
            default:
                return <OverviewContent />;
        }
    };

    return (
        <div className="app-layout" style={{ marginLeft: '20px', marginRight: '20px', marginBottom: '100px' }}>

            <div className="main-container">
                <Sidebar />

                <main className="main-content">
                    <div className="tabs-container">
                        <nav className="tabs-nav">
                            {tabs.map((tab) =>
                                <button
                                    key={tab}
                                    onClick={() => setActiveTab(tab)}
                                    className={`tab-btn ${activeTab === tab ? 'active' : ''}`}>

                                    {tab}
                                </button>
                            )}
                        </nav>
                    </div>

                    <div className="tab-content">
                        {renderTabContent()}
                    </div>
                </main>
            </div>
        </div>);

}

export default ProfilePage;